import { useState, useEffect, useRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { isEqual } from 'lodash';

// inspired from https://github.com/trojanowski/react-apollo-hooks/blob/master/src/useSubscription.ts
export const useLocalSubscription = (query, options) => {
  const [variables, setVariables] = useState(options?.variables);
  const client = useApolloClient();
  const { onData } = options;
  const onDataRef = useRef(onData);
  onDataRef.current = onData;

  useEffect(() => {
    if (isEqual(variables, options?.variables)) return;
    setVariables(options?.variables);
  }, [options, variables]);

  useEffect(() => {
    const observer = client.subscribe({
      query,
      variables
    });

    const subscription = observer.subscribe(event => {
      onDataRef.current && onDataRef.current(event, observer, subscription);
    });

    return () => subscription.unsubscribe();
  }, [query, variables, client]);
};
